/**
 * カートページ リロード制御
 *
 * 以下2つの問題を解消する：
 * 1. BFCache問題: ブラウザバックで復元された場合にサイレントリロード
 * 2. 長時間放置問題: 1時間超過 or 日付変更を検知してアラート→リロード
 */
(function () {
  const BASE_TIME = new Date();
  const TIMEOUT_MS = 60 * 60 * 1000; // 1時間
  let reloading = false;

  function toDateString(d) {
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  function checkAndReload() {
    if (reloading) return;
    const now = new Date();
    const elapsed = now.getTime() - BASE_TIME.getTime();
    const isDateChanged = toDateString(now) !== toDateString(BASE_TIME);

    if (isDateChanged) {
      reloading = true;
      window.alert('日付が変わりました。再読み込みを行います。');
      window.location.reload();
      return;
    }

    if (elapsed > TIMEOUT_MS) {
      reloading = true;
      window.alert('1時間以上経過しました。再読み込みを行います。');
      window.location.reload();
    }
  }

  // BFCache復元: サイレントリロード
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      reloading = true;
      window.location.reload();
    }
  });

  // タブ切り替えからの復帰を検知
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      checkAndReload();
    }
  });

  // タブがアクティブなまま放置するケースを定期チェック（60秒間隔）
  setInterval(checkAndReload, 60000);
})();
